import React, { useEffect, useState } from "react";
import useModalStore from "../StatesStore/ModalStore";
import { useLocation, useNavigate } from "react-router-dom";
import useUrlState from "../StatesStore/CurrentURL";
import { UserAuth } from "../Context";
import useNotification from "../hooks/useNotification";
import { toast } from "react-toastify";
import { toastOptions } from "../lib/toastOptions";
import { Modal } from "react-bootstrap";
import CheckFollow from "../UserProfile/CheckFollow";
const FollowerSidebarBrands = ({ followers, setFollowers, followerCount }) => {
  console.log("FollowerSidebarBrands", followers);

  const { user } = UserAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [filteredFollowers, setFilteredFollowers] = useState(followers);
  const { seturl } = useUrlState();
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const { openModal } = useModalStore();
  const { deleteNotification } = useNotification();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const [selectedTab, setSelectedTab] = useState("users");

  /*For Web View Modal*/
  const [show, setShow] = useState(false);
  const closeModal = () => setShow(false);
  const handleShowModal = () => setShow(true);

  useEffect(() => {
    if (searchTerm.trim() === "") {
      setFilteredFollowers(followers);
    } else {
      const filtered = followers.filter((follower) => {
        const name =
          selectedTab === "users" ? follower.userName : follower.displayName;
        const title = follower.userTitle || "";
        return (
          name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          title?.toLowerCase().includes(searchTerm.toLowerCase())
        );
      });
      setFilteredFollowers(filtered);
    }
  }, [searchTerm, followers, selectedTab]);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleProfileClick = (follower) => {
    closeSidebar();
    navigate(`/userProfile/${follower?.uid}`);
  };
  const toggleSidebar = () => {
    setIsOpen(!isOpen);
    seturl(location?.pathname);
  };
  const closeSidebar = () => setIsOpen(false);

  const unfollowUser = async (currentUserId, profileUserId) => {
    if (!currentUserId || !profileUserId) return;

    try {
      await fetch(`${process.env.REACT_APP_API}/api/unfollowUser`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          senderId: currentUserId,
          receiverId: profileUserId,
        }),
      });
    } catch (error) {
      console.error("Error unfollowing user:", error);
    }
  };

  const removeFollower = async (friendUID) => {
    try {
      await unfollowUser(friendUID, user?.uid);
      let tempFollowers = followers.filter((item) => item?.uid !== friendUID);
      setFollowers(tempFollowers);
      toast.success("User removed from followers successfully", toastOptions);
      await deleteNotification({
        userId: user?.uid,
        id: friendUID,
        type: "followed",
        by: "user",
      });
    } catch (error) {
      console.error(error);
      toast.error("Failed to remove user", toastOptions);
    }
  };
  const handleClickRemoveFollower = (follower) => {
    const DATA = {
      userData: follower,
      modalHeaderText: "Remove follower?",
      modalBodyText: () => {
        return (
          <div
            style={{
              fontFamily: "Inter",
              fontWeight: "400",
              fontSize: "16px",
              letterSpacing: "0%",
              lineHeight: isSmallScreen ? "116%" : "146%",
              textAlign: isSmallScreen ? "center" : "left",
              verticalAlign: isSmallScreen ? "middle" : "",
              color: "#676A79",
            }}
          >
            We won't tell{" "}
            <span
              style={{
                fontWeight: "500",
                color: "#000000",
              }}
            >
              {follower?.userName}
            </span>{" "}
            that they were removed from your followers.
          </div>
        );
      },
      handleConfirm: () => {
        removeFollower(follower?.uid);
      },
      confirmButtonText: "Remove",
    };
    openModal("RemoveFollowerFollowingModal", "user", DATA);
  };

  return (
    <>
      {/* Styles */}
      <style jsx>
        {`
          .toggle-btn {
            font-size: 14px;
            cursor: pointer;
            color: black;
            border: none;
            font-weight: 400;
            text-decoration: none;
          }

          .sidebar {
            position: fixed;
            top: 0px;
            right: -100%;
            width: 100%;
            height: 100%;
            background-color: white;
            color: black;
            transition: right 0.3s ease-in-out;
            z-index: 1025;
            overflow-y: scroll;
          }

          .sidebar.open {
            right: 0;
          }

          .linkStyle {
            font-family: Inter;
            font-weight: 500;
            font-size: 18px;
            line-height: 100%;
            text-align: center;
            margin: 0rem 1rem;
            display: inline-block;
            padding-bottom: 2px;
          }

          .search-bar {
            height: 46px;
            padding: 5px 16px;
            position: relative;
          }

          .search-input {
            border-radius: 12px;
            border-width: 0.86px;
            padding: 6px;
            padding-left: 2rem;
            border: 0.86px solid #c3c3c3;
            font-size: 14px;
            width: 100%;
          }

          .followerFollowingModal .modal-content {
            border-radius: 20px !important;
            width: 41.25rem;
            overflow: hidden;
            max-height: 576px;
            // max-height: 80vh; /* Set maximum height relative to viewport */
          }

          .followerFollowingModal .modal-dialog {
            max-width: 41.25rem;
            margin: 1rem auto; /* Add some margin */
          }

          .modal-backdrop {
            z-index: 1060 !important;
          }

          .search-bar-mobile {
            height: 46px;
            position: relative;
          }

          .search-input-mobile {
            height: 46px !important;
            font-size: 15px;
            border-radius: 12px;
            border-width: 0.86px;
            padding: 6px;
            padding-left: 2rem;
            border: 0.86px solid #c3c3c3;
            width: 100%;
          }

          .follower-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }

          .followers-list {
            display: flex;
            flex-direction: column;
            gap: 1rem;
            max-height: 324px;
            overflow-y: auto;
            padding-right: 8px;
          }

          /* Custom scrollbar styling */
          .followers-list::-webkit-scrollbar {
            width: 6px;
          }

          .followers-list::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 10px;
          }

          .followers-list::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 10px;
          }

          .followers-list::-webkit-scrollbar-thumb:hover {
            background: #555;
          }

          .chatButton div {
            color: #005fda;
          }

          .chatButton:hover {
            background-color: #005fda;
          }

          .chatButton:hover div {
            color: white;
          }
          .disabled-link {
            cursor: not-allowed !important;
            opacity: 0.5;
            pointer-events: none;
          }
          .tab-container {
            display: flex;

            margin-bottom: 16px;
          }

          .tab {
            padding: 8px 16px;
            cursor: pointer;
            font-family: Inter;
            font-weight: 500;
            font-size: 16px;
            color: #6b7280;
          }

          .tab.active {
            color: #005fda;
            border-bottom: 2px solid #005fda;
          }
        `}
      </style>
      {/* Toggle Button */}
      {isSmallScreen ? (
        <div
          onClick={toggleSidebar}
          style={{
            cursor: "pointer",
            fontFamily: "Inter",
            fontWeight: "400",
            fontSize: "14px",
            lineHeight: "100%",
            letterSpacing: "0%",
            color: "#000000",
          }}
        >
          {followerCount} Followers
        </div>
      ) : (
        <div
          className="d-flex align-items-start"
          style={{ whiteSpace: "nowrap", gap: "22px" }}
        >
          {/* Follower Count */}
          <div
            style={{
              fontFamily: "Inter",
              fontWeight: 500,
              fontSize: "18px",
              lineHeight: "100%",
              letterSpacing: "0%",
              color: "#000000",
              opacity: followerCount <= 0 ? 0.5 : 1,
              cursor: followerCount <= 0 ? "default" : "pointer",
            }}
            className={`${followerCount <= 0 ? "disabled-link" : ""}`}
            onClick={() => {
              handleShowModal(true);
            }}
          >
            {followerCount} Followers
          </div>
        </div>
      )}

      {/* Backdrop */}
      {/* {isOpen && <div className="backdrop" onClick={closeSidebar} />} */}

      {/* Sidebar */}
      {isSmallScreen ? (
        <div className={`sidebar ${isOpen ? "open" : ""}`}>
          <div
            style={{
              position: "sticky",
              top: "0rem",
              zIndex: 1,
              backgroundColor: "white",
            }}
          >
            {/* TopHeader */}
            <div
              className="d-flex align-items-center w-100 border-bottom bg-white"
              style={{
                padding: "0.75rem 1rem",
                gap: "8px",
                height: "46px",
              }}
            >
              <div onClick={closeSidebar}>
                <i
                  className="bi bi-chevron-left grey"
                  style={{ fontSize: "1.375rem" }}
                ></i>
              </div>
              <div
                className="h5 mb-0"
                style={{
                  fontFamily: "Inter",
                  fontWeight: "600",
                  fontSize: "1.125rem",
                  lineHeight: "100%",
                  letterSpacing: "0%",
                  textAlign: "center",
                }}
              >
                {/* UserProfile */}
                Followers
              </div>
              <div></div>
            </div>

            {/* Search bar */}
            {followerCount > 0 && (
              <div className="search-bar mt-2">
                <svg
                  style={{
                    position: "absolute",
                    top: "10px",
                    left: "23px",
                    height: "24px",
                  }}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.5077 8.40593C11.1961 8.43895 10.9702 8.71838 11.0032 9.03006C11.0363 9.34174 11.3157 9.56763 11.6274 9.53461L11.5077 8.40593ZM12.9086 10.2894C13.0308 10.5781 13.3638 10.713 13.6525 10.5908C13.9411 10.4686 14.076 10.1356 13.9538 9.84695L12.9086 10.2894ZM15.2698 14.3715C15.048 14.1501 14.6887 14.1504 14.4673 14.3722C14.2458 14.594 14.2462 14.9533 14.468 15.1747L15.2698 14.3715ZM17.0316 17.7338C17.2534 17.9553 17.6127 17.955 17.8342 17.7331C18.0556 17.5113 18.0553 17.152 17.8334 16.9305L17.0316 17.7338ZM11.6274 9.53461C12.1741 9.47668 12.6943 9.78316 12.9086 10.2894L13.9538 9.84695C13.5447 8.88045 12.5515 8.29533 11.5077 8.40593L11.6274 9.53461ZM14.468 15.1747L17.0316 17.7338L17.8334 16.9305L15.2698 14.3715L14.468 15.1747Z"
                    fill="#676A79"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.46452 14.6801C6.76291 13.9765 6.28703 13.0862 6.09593 12.1195C5.90323 11.1501 6.00218 10.1466 6.38068 9.23146C6.75594 8.32151 7.39661 7.54074 8.22224 6.98718C9.89738 5.86365 12.1026 5.86365 13.7777 6.98718C14.6034 7.54074 15.2441 8.32151 15.6193 9.23146C15.9978 10.1466 16.0968 11.1501 15.904 12.1195C15.713 13.0862 15.2371 13.9765 14.5354 14.6801C13.6063 15.6164 12.3314 16.1445 11 16.1445C9.66861 16.1445 8.3937 15.6164 7.46452 14.6801Z"
                    stroke="#676A79"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <input
                  type="text"
                  id="searchInput"
                  className="search-input"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            )}
          </div>
          {/* Profiles */}

          <div style={{ padding: "10px 0px" }}>
            {filteredFollowers?.length > 0 ? (
              filteredFollowers.map((otherUser) => {
                return (
                  <>
                    <div
                      key={otherUser?.uid}
                      style={{ padding: "0.5rem 1rem" }}
                    >
                      <div
                        className="d-flex align-items-center justify-content-between"
                        style={{ gap: "0.75rem" }}
                      >
                        <div
                          className="d-flex align-items-center"
                          style={{ gap: "0.75rem" }}
                        >
                          <div onClick={() => handleProfileClick(otherUser)}>
                            <img
                              src={
                                otherUser?.photo ||
                                `https://ui-avatars.com/api/?name=${otherUser?.userName?.[0]?.toUpperCase()}`
                              }
                              loading="lazy"
                              width={"50px"}
                              height={"50px"}
                              style={{
                                borderRadius: "12px",
                                width: "50px",
                                height: "50px",
                                objectFit: "cover",
                                objectPosition: "top",
                              }}
                              alt=""
                            />
                          </div>
                          <div
                            onClick={() => handleProfileClick(otherUser)}
                            className="d-flex flex-column"
                            style={{ gap: "0.25rem" }}
                          >
                            <div
                              className="text-truncate"
                              style={{
                                fontFamily: "Inter",
                                fontWeight: "600",
                                fontSize: "16px",
                                lineHeight: "100%",
                                letterSpacing: "0%",
                                color: "black",
                                width:
                                  user?.uid !== otherUser?.uid
                                    ? "163px"
                                    : "100%",
                              }}
                            >
                              {otherUser?.userName || "Unknown"}
                              {user?.uid === otherUser?.uid && (
                                <span
                                  style={{ color: "#676A79", fontWeight: 400 }}
                                >
                                  {" "}
                                  (You){" "}
                                </span>
                              )}
                            </div>
                            <div
                              className="text-truncate"
                              style={{
                                fontFamily: "Inter",
                                fontWeight: "400",
                                fontSize: "15px",
                                lineHeight: "100%",
                                letterSpacing: "0%",
                                color: "#676A79",
                                width: "163px",
                              }}
                            >
                              {otherUser?.userTitle || "No bio available"}
                            </div>
                          </div>
                        </div>
                        {user?.uid !== otherUser?.uid && (
                          <div
                            className="d-flex align-items-center"
                            style={{ gap: "2px" }}
                          >
                            <CheckFollow myData={user} friendData={otherUser} />
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                );
              })
            ) : (
              <div
                style={{
                  padding: "3rem 0px",
                  fontFamily: "Inter",
                  fontWeight: "400",
                  fontSize: "16px",
                  letterSpacing: "0%",
                  textAlign: "center",
                  verticalAlign: "middle",
                  color: "#676A79",
                }}
              >
                {searchTerm
                  ? `No matching followers found`
                  : "No followers found"}
              </div>
            )}
          </div>
        </div>
      ) : (
        <Modal
          show={show}
          onHide={closeModal}
          centered
          className="followerFollowingModal"
        >
          <Modal.Body style={{ padding: "40px " }}>
            <div className="d-flex flex-column" style={{ gap: "24px" }}>
              <div className="d-flex w-100 justify-content-between">
                <div
                  style={{
                    fontFamily: "Inter",
                    color: "#101828",
                    fontWeight: "600",
                    fontSize: "24px",
                    lineHeight: "24px",
                    letterSpacing: "0%",
                  }}
                >
                  Followers
                </div>
                <button
                  type="button"
                  style={{
                    boxSizing: "border-box",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "27px",
                    height: "27px",
                    background: "#FFFFFF",
                    border: "1px solid #FF3B30",
                    boxShadow: "1px 1px 5px rgba(30, 30, 30, 0.14)",
                    borderRadius: "25px",
                    flex: "none",
                    order: "1",
                    flexGrow: "0",
                  }}
                  onClick={closeModal}
                >
                  <svg
                    style={{ width: "11px" }}
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1L1 13M1 1L13 13"
                      stroke="#FF3B30"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
              {/* Tabs for Users/Brands */}
              <div
                className="d-flex align-items-center"
                style={{ gap: "60px" }}
              >
                <div
                  onClick={() => setSelectedTab("users")}
                  className="linkStyle"
                  style={{
                    borderBottom:
                      selectedTab === "users"
                        ? `1px solid rgb(0, 95, 218)`
                        : "",
                    color: selectedTab === "users" ? "#005FDA" : "#667085",
                    fontSize: "18px",
                    fontWeight: 500,
                    margin: 0,
                    cursor: "pointer",
                  }}
                >
                  Users
                </div>
              </div>
              <div className="d-flex flex-column " style={{ gap: "24px" }}>
                {followerCount > 5 && (
                  <div className="search-bar-mobile">
                    <svg
                      style={{
                        position: "absolute",
                        top: "10.5px",
                        left: "5px",
                        height: "26px",
                      }}
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.5077 8.40593C11.1961 8.43895 10.9702 8.71838 11.0032 9.03006C11.0363 9.34174 11.3157 9.56763 11.6274 9.53461L11.5077 8.40593ZM12.9086 10.2894C13.0308 10.5781 13.3638 10.713 13.6525 10.5908C13.9411 10.4686 14.076 10.1356 13.9538 9.84695L12.9086 10.2894ZM15.2698 14.3715C15.048 14.1501 14.6887 14.1504 14.4673 14.3722C14.2458 14.594 14.2462 14.9533 14.468 15.1747L15.2698 14.3715ZM17.0316 17.7338C17.2534 17.9553 17.6127 17.955 17.8342 17.7331C18.0556 17.5113 18.0553 17.152 17.8334 16.9305L17.0316 17.7338ZM11.6274 9.53461C12.1741 9.47668 12.6943 9.78316 12.9086 10.2894L13.9538 9.84695C13.5447 8.88045 12.5515 8.29533 11.5077 8.40593L11.6274 9.53461ZM14.468 15.1747L17.0316 17.7338L17.8334 16.9305L15.2698 14.3715L14.468 15.1747Z"
                        fill="#676A79"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.46452 14.6801C6.76291 13.9765 6.28703 13.0862 6.09593 12.1195C5.90323 11.1501 6.00218 10.1466 6.38068 9.23146C6.75594 8.32151 7.39661 7.54074 8.22224 6.98718C9.89738 5.86365 12.1026 5.86365 13.7777 6.98718C14.6034 7.54074 15.2441 8.32151 15.6193 9.23146C15.9978 10.1466 16.0968 11.1501 15.904 12.1195C15.713 13.0862 15.2371 13.9765 14.5354 14.6801C13.6063 15.6164 12.3314 16.1445 11 16.1445C9.66861 16.1445 8.3937 15.6164 7.46452 14.6801Z"
                        stroke="#676A79"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <input
                      type="text"
                      id="searchInput"
                      className="search-input-mobile"
                      placeholder="Search"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                )}
                <div className="followers-list">
                  {filteredFollowers.length > 0 ? (
                    filteredFollowers.map((otherUser) => (
                      <div key={otherUser?.uid} className="follower-item">
                        <div
                          onClick={() => {
                            handleProfileClick(otherUser);
                            closeModal();
                          }}
                          className="d-flex align-items-center"
                          style={{ gap: "0.75rem" }}
                        >
                          <div className="mb-0" style={{ cursor: "pointer" }}>
                            <img
                              src={
                                selectedTab === "users"
                                  ? otherUser?.photo ||
                                    `https://ui-avatars.com/api/?name=${otherUser?.userName?.[0]?.toUpperCase()}`
                                  : otherUser?.logoUrl ||
                                    `https://ui-avatars.com/api/?name=${otherUser?.displayName?.[0]?.toUpperCase()}`
                              }
                              loading="lazy"
                              width={"50px"}
                              height={"50px"}
                              style={{
                                borderRadius: "12px",
                                width: "50px",
                                height: "50px",
                                objectFit: "cover",
                                objectPosition: "top",
                              }}
                              alt=""
                            />
                          </div>
                          <div
                            className="d-flex flex-column"
                            style={{ gap: "0.25rem" }}
                          >
                            <div
                              className="follower-name"
                              style={{
                                fontFamily: "Inter",
                                color: "#000000",
                                fontWeight: 600,
                                fontSize: "20px",
                                lineHeight: "100%",
                                cursor: "pointer",
                              }}
                            >
                              {selectedTab === "users"
                                ? otherUser?.userName
                                : otherUser?.displayName || "Unknown"}
                              {user?.uid === otherUser?.uid && (
                                <span
                                  style={{ color: "#676A79", fontWeight: 400 }}
                                >
                                  {" "}
                                  (You){" "}
                                </span>
                              )}
                            </div>

                            <div
                              className="follower-bio"
                              style={{
                                fontFamily: "Inter",
                                color: "#676A79",
                                fontWeight: 400,
                                fontSize: "16px",
                                lineHeight: "1.3",
                                cursor: "pointer",
                              }}
                            >
                              {otherUser?.userTitle || "No bio available"}
                            </div>
                          </div>
                        </div>
                        {user?.uid !== otherUser?.uid && (
                          <div
                            className="d-flex align-items-center"
                            style={{ gap: "6px" }}
                          >
                            <CheckFollow myData={user} friendData={otherUser} />
                          </div>
                        )}
                      </div>
                    ))
                  ) : (
                    <div style={{ textAlign: "center", padding: "20px" }}>
                      {searchTerm
                        ? `No matching followers found`
                        : "No followers found"}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default FollowerSidebarBrands;
